// extracted by mini-css-extract-plugin
export default {"icon":"k50bl5","label":"HNi3Jz"};